import { initializeApp, getApps } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { getStripePayments } from "@stripe/firestore-stripe-payments";

const config = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
};

let firebaseApp;
if (!getApps().length) {
  firebaseApp = initializeApp(config);
}

export const app = firebaseApp;
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, "europe-west1");
export const payments = getStripePayments(app, {
  productsCollection: "products",
  customersCollection: "customers",
});

export const ADMIN_UIDS = new Set(["YAWM4bM63mON5p5bk6kApVDhRHk1"]);
export const isAdmin = () => auth.currentUser && ADMIN_UIDS.has(auth.currentUser.uid);
